import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { BusinesshoursService } from 'src/app/POS/POSServices/Setup/businesshours.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-business-hours',
  templateUrl: './business-hours.component.html',
  styleUrls: ['./business-hours.component.scss']
})
export class BusinessHoursComponent implements OnInit {
  hoursId:any;
  weekdayserrormessage:boolean=false;
  isReadytoUpdatebusinesshour : boolean = false;
  weekdays = [
    { text: "Monday", value: "Monday" },
    { text: "Tuesday", value: "Tuesday" },
    { text: "Wednesday", value: "Wednesday" },
    { text: "Thursday", value: "Thursday" },
    { text: "Friday", value: "Friday" },
    { text: "Saturday", value: "Saturday" },
    { text: "Sunday", value: "Sunday" },
    { text: "All", value: "All" },
  ];
  DateTime:any;
  merchantdata: UserPOSData ;
  isNewbusiness: boolean = true;
  isUpdatebusiness: boolean = false;
  rows;
  date = new FormControl('');
  WeekDay  =  new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  HourType  =  new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  TimeFrom  = new FormControl("", [Validators.required]);
  TimeTo  = new FormControl("", [Validators.required]);
id= new FormControl("", [Validators.required]);
ContactPerference  = new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: BusinesshoursService,
    private activatedRoute: ActivatedRoute,

  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetEmployeeDetails();
  }
  getGetEmployeeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      this.hoursId=params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
if(this.hoursId>0)
{
  this.service.GetBusinessHoursDetail(form).subscribe(result => {   
    console.log("result.Id---" + result);
    if (result.Id > 0) {
      this.DateTime=result.dateTime;
      this.isUpdatebusiness = true;
      this.isNewbusiness = false;
      this.rows = result;
    } else {
      this.isUpdatebusiness = false;
      this.isNewbusiness = true;
    }
  });

}
  
  }


  newBusinesshours() {
   
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      WeekDay :"",
      HourType  :"",
      TimeFrom   :"",
      TimeTo   :"",
      };
    form.WeekDay = this.WeekDay.value;
    form.HourType = this.HourType.value;
    form.TimeFrom = this.TimeFrom.value;
    form.TimeTo = this.TimeTo.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddBusinessHours(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        localStorage.removeItem('BusinessHourslist');
        swal("Added", "Business Hours Added Successfully", "success");  
        this.router.navigate(["/pos/businesshour/manage"]);
    }
    });
  }
  
  updatebusinesshours()
  {
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      WeekDay :"",
      HourType  :"",
      TimeFrom   :"",
      TimeTo   :"",
      DateTime:"",
      id:""
      };
      form.WeekDay = this.WeekDay.value;
      form.HourType = this.HourType.value;
      form.TimeFrom = this.TimeFrom.value;
      form.TimeTo = this.TimeTo.value;
      form.id=this.rows.Id ;
      form.DateTime=this.DateTime;

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;

    this.service.UpdateBusinessHours(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        localStorage.removeItem('BusinessHourslist');
        swal("Updated", "Business Hours Updated Successfully", "success");  
        this.router.navigate(["/pos/businesshour/manage"]);
      }
    });
  }
 
weekdayerror() {
  return this.WeekDay.hasError("required") ? "Week Day  is required"
    : this.WeekDay.hasError("pattern") ? "Week Day should be allow only alphabets" : "";
}

hourtypeerror() {
  return this.HourType.hasError("required") ? "HourType  is required"
    : this.HourType.hasError("pattern") ? "HourType should be allow only alphabets" : "";
}



timetoerror() {
  return this.TimeTo.hasError("required") ? "Time To is required"
    : this.TimeTo.hasError("pattern") ? "Time To  should be allow only alphabets" : "";
}

timefromerror() {
  return this.TimeFrom.hasError("required") ? "Time from   is required":"";
    // : this.TimeFrom.hasError("pattern") ? "Time from should be allow only alphabets" : "";
}
onKey()
{
  this.isReadytoUpdatebusinesshour = true;
}


selectweekdays()
{
  let form = { merchantKeyId: "", WeekDay:"", PosSubscriptionId:""};
  let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
  this.activatedRoute.params.subscribe(params => {

    form.WeekDay = this.WeekDay.value;
    form.PosSubscriptionId= merchantdata.PosSubscriptionId;
    form.merchantKeyId = params["merchantKeyId"];   
    form.PosSubscriptionId  =merchantdata.PosSubscriptionId;
    console.log("formdata---" + form);
  });   
  this.service.Getbusinesshoursweekdaysdays(form).subscribe(result => {   
    if(result!=null)
    {
      this.weekdayserrormessage=true;  
  
    }
    else
    {
      this.weekdayserrormessage=false;  
    }
  
  });

}
}

